import { render } from "./EditDynamicForm.vue?vue&type=template&id=bc5fc63c&scoped=true"
import script from "./EditDynamicForm.vue?vue&type=script&lang=js"
export * from "./EditDynamicForm.vue?vue&type=script&lang=js"

import "./EditDynamicForm.vue?vue&type=style&index=0&id=bc5fc63c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc5fc63c"]])

export default __exports__